<template>
  <v-card outlined color="grey lighten-5" class="mx-auto header-banner-card">
    <v-row dense class="ma-0">
      <v-col class="pa-0">
        <a href="https://www.espa.gr/en/Pages/default.aspx/" target="_blank">
          <v-img
            :src="require('../assets/BANNER_MDT_ETPA2.jpg')"
            aspect-ratio="13"
            contain
            class="header-banner-image"
            alt="Visit the ESPA website"
          ></v-img>
        </a>
      </v-col>
    </v-row>

    <p style="text-align: center" class="ma-0 pa-0">
      <strong>©2022 — Εύδοξος</strong>
    </p>
  </v-card>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.header-banner-card {
  width: 620px;
  max-width: 620px;
}

.header-banner-image {
  width: 100%;
}
</style>
